import * as locationActions from './locationActions';
import * as generalActions from './generalActions';

export const ActionCreators = {
  ...generalActions,
  ...locationActions,
};